<template>
  <el-dialog :title="formData.id ? 'Зардал засварлах' : 'Шинэ зардал үүсгэх'" v-model="createCostDialog" width="60%"
    @close="handleClose">
    <div>
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="150px">
        <el-row v-if="!isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Огноо" prop="date">
              <el-date-picker
                v-model="formData.date"
                type="date"
                placeholder="Огноо сонгоно уу"
                style="width: 100%"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Салбар" prop="branch_id">
              <el-select v-model="formData.branch_id" placeholder="Салбар сонгоно уу" style="width: 100%">
                <el-option
                  v-for="branch in branches"
                  :key="branch.id"
                  :label="branch.branch_name"
                  :value="branch.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Огноо" prop="date">
              <el-date-picker
                v-model="formData.date"
                type="date"
                placeholder="Огноо сонгоно уу"
                style="width: 100%"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Шилжүүлэх салбар" prop="transfer_from_branch_id">
              <el-select v-model="formData.transfer_from_branch_id" placeholder="Шилжүүлэх салбар сонгоно уу" style="width: 100%">
                <el-option
                  v-for="branch in branches"
                  :key="branch.id"
                  :label="branch.branch_name"
                  :value="branch.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Хүлээн авах салбар" prop="transfer_to_branch_id">
              <el-select v-model="formData.transfer_to_branch_id" placeholder="Хүлээн авах салбар сонгоно уу" style="width: 100%">
                <el-option
                  v-for="branch in branches"
                  :key="branch.id"
                  :label="branch.branch_name"
                  :value="branch.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Дүн" prop="amount">
              <el-input-number
                v-model="formData.amount"
                :min="0"
                :precision="2"
                placeholder="Дүнг оруулна уу"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Дансны дугаар" prop="account_number">
              <el-input v-model="formData.account_number" placeholder="Дансны дугаар оруулна уу" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!isTransferType" :gutter="20">
          <el-col :span="12">
            <el-form-item label="Дүн" prop="amount">
              <el-input-number
                v-model="formData.amount"
                :min="0"
                :precision="2"
                placeholder="Дүнг оруулна уу"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Дансны дугаар" prop="account_number">
              <el-input v-model="formData.account_number" placeholder="Дансны дугаар оруулна уу" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item v-if="isRentType" label="Түрээсийн эхлэх хугацаа" prop="rent_start_date">
              <el-date-picker
                v-model="formData.rent_start_date"
                type="date"
                placeholder="Түрээсийн эхлэх хугацаа сонгоно уу"
                style="width: 100%"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
            <el-form-item v-if="isDeliveryType" label="Хүргэлт хийсэн хэрэглэгч" prop="delivery_user_id">
              <el-select v-model="formData.delivery_user_id" placeholder="Ажилчин сонгоно уу" style="width: 100%">
                <el-option
                  v-for="worker in workers"
                  :key="worker.id"
                  :label="`${worker.firstName || ''} ${worker.lastName || ''}`.trim() || worker.phone1"
                  :value="worker.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="isSalaryType" label="Ажилчин" prop="employee_id">
              <el-select v-model="formData.employee_id" placeholder="Ажилчин сонгоно уу" style="width: 100%">
                <el-option
                  v-for="employee in employees"
                  :key="employee.id"
                  :label="`${employee.firstName || ''} ${employee.lastName || ''}`.trim() || employee.phone1"
                  :value="employee.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="isRentType" label="Түрээсийн дуусах хугацаа" prop="rent_end_date">
              <el-date-picker
                v-model="formData.rent_end_date"
                type="date"
                placeholder="Түрээсийн дуусах хугацаа сонгоно уу"
                style="width: 100%"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-if="!isSalaryType && !isTransferType" label="Тайлбар" prop="description">
          <el-input type="textarea" v-model="formData.description" placeholder="Тайлбар оруулна уу" :rows="3" />
        </el-form-item>
        <el-form-item v-if="isTransferType" label="Тайлбар" prop="description">
          <el-input type="textarea" v-model="formData.description" placeholder="Тайлбар оруулна уу" :rows="3" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">Хадгалах</el-button>
          <el-button @click="handleClose">Цуцлах</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import services from '@/services'
import {
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,
  ElMessage,
  ElDatePicker,
  ElSelect,
  ElOption,
  ElInputNumber
} from 'element-plus'
import {
  mapActions,
  mapState
} from 'vuex'

export default {
  name: 'CreateCostDialog',

  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    ElDatePicker,
    ElSelect,
    ElOption,
    ElInputNumber
  },
  props: {
    selectedCost: {
      type: Object,
      default: () => ({})
    }
  },
  created () {
    this.loadBranches()
    this.loadWorkers()
    this.loadEmployees()
  },
  computed: {
    ...mapState(['createCostDialog', 'user']),
    rules () {
      return {
        date: [{
          required: true,
          message: 'Огноо сонгоно уу',
          trigger: 'change'
        }],
        amount: [{
          required: true,
          message: 'Дүнг оруулна уу',
          trigger: 'blur'
        }],
        transfer_from_branch_id: [{
          required: this.isTransferType,
          message: 'Шилжүүлэх салбар сонгоно уу',
          trigger: 'change'
        }],
        transfer_to_branch_id: [{
          required: this.isTransferType,
          message: 'Хүлээн авах салбар сонгоно уу',
          trigger: 'change'
        }]
      }
    }
  },
  data () {
    return {
      branches: [],
      workers: [],
      employees: [],
      isRentType: false,
      isDeliveryType: false,
      isSalaryType: false,
      isTransferType: false,
      formData: {
        date: '',
        created_by_user_id: null,
        description: '',
        amount: null,
        account_number: '',
        branch_id: null,
        delivery_user_id: null,
        employee_id: null,
        transfer_from_branch_id: null,
        transfer_to_branch_id: null,
        rent_start_date: '',
        rent_end_date: ''
      }
    }
  },
  watch: {
    selectedCost: {
      immediate: true,
      handler (newValue) {
        if (newValue && newValue.id) {
          this.formData = {
            ...newValue,
            date: newValue.date ? newValue.date.split('T')[0] : '',
            rent_start_date: newValue.rent_start_date ? newValue.rent_start_date.split('T')[0] : '',
            rent_end_date: newValue.rent_end_date ? newValue.rent_end_date.split('T')[0] : '',
            transfer_from_branch_id: newValue.transfer_from_branch_id || null,
            transfer_to_branch_id: newValue.transfer_to_branch_id || null
          }
        } else {
          this.formData = {
            date: '',
            created_by_user_id: this.user?.id || null,
            description: '',
            amount: null,
            account_number: '',
            branch_id: null,
            delivery_user_id: null,
            employee_id: null,
            transfer_from_branch_id: null,
            transfer_to_branch_id: null,
            rent_start_date: '',
            rent_end_date: ''
          }
        }
      }
    },
    createCostDialog: {
      handler (newValue) {
        if (newValue) {
          // Dialog нээгдэхэд route-аас typeId-г шалгах
          this.checkCostType()
        }
      },
      immediate: true
    },
    '$route' (to, from) {
      // Route өөрчлөгдөхөд CostType шалгах
      if (this.createCostDialog) {
        this.checkCostType()
      }
    }
  },
  methods: {
    ...mapActions(['setCreateCostDialog']),
    handleClose () {
      this.formData = {
        date: '',
        created_by_user_id: null,
        description: '',
        amount: null,
        account_number: '',
        branch_id: null,
        delivery_user_id: null,
        employee_id: null,
        transfer_from_branch_id: null,
        transfer_to_branch_id: null,
        rent_start_date: '',
        rent_end_date: ''
      }
      this.setCreateCostDialog(false)
    },
    async loadWorkers () {
      try {
        const response = await services.get('workersList')
        if (response && response.type === 'success') {
          this.workers = response.data || []
        } else if (response && response.data) {
          this.workers = response.data || []
        }
      } catch (error) {
        console.error('Error loading workers:', error)
        this.workers = []
      }
    },
    async checkCostType () {
      // Transfer цэс эсэхийг шалгах
      if (this.$route.path === '/costs/transfer' || this.$route.name === 'costsTransfer') {
        this.isTransferType = true
        this.isRentType = false
        this.isDeliveryType = false
        this.isSalaryType = false
        return
      }
      // CostType-ийн мэдээллийг авах
      const typeId = this.$route.params.typeId
      if (typeId) {
        try {
          const response = await services.get('costTypes')
          if (response && response.type === 'success') {
            const costType = response.data.find(ct => ct.id === parseInt(typeId))
            if (costType) {
              this.isRentType = costType.name && costType.name.toLowerCase().includes('түрээс')
              this.isDeliveryType = costType.name && costType.name.toLowerCase().includes('хүргэлт')
              this.isSalaryType = costType.name && costType.name.toLowerCase().includes('цалин')
              this.isTransferType = costType.name && (costType.name.toLowerCase().includes('шилжүүлэлт') || costType.name.toLowerCase().includes('шилжүүлэх'))
            }
          }
        } catch (error) {
          console.error('Error loading cost type:', error)
        }
      } else {
        this.isTransferType = false
      }
    },
    async loadEmployees () {
      try {
        const response = await services.get('workersList')
        if (response && response.type === 'success') {
          this.employees = response.data || []
        } else if (response && response.data) {
          this.employees = response.data || []
        }
      } catch (error) {
        console.error('Error loading employees:', error)
        this.employees = []
      }
    },
    async submitForm () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            // Route параметрээс typeId авч байна
            let typeId = this.$route.params.typeId
            // Transfer цэс дээр typeId байхгүй тул null байна
            if (this.$route.path === '/costs/transfer' || this.$route.name === 'costsTransfer') {
              typeId = null
            }
            // isTransferType шалгах (CostType-ийн нэрийг шалгах)
            if (!this.isTransferType && typeId) {
              // CostType-ийн мэдээллийг авах
              try {
                const response = await services.get('costTypes')
                if (response && response.type === 'success') {
                  const costType = response.data.find(ct => ct.id === parseInt(typeId))
                  if (costType && (costType.name.toLowerCase().includes('шилжүүлэлт') || costType.name.toLowerCase().includes('шилжүүлэх'))) {
                    this.isTransferType = true
                  }
                }
              } catch (error) {
                console.error('Error loading cost type:', error)
              }
            }

            // Payload үүсгэх
            const payload = {
              type_id: typeId ? parseInt(typeId) : null,
              date: this.formData.date || null,
              created_by_user_id: this.user?.id || null,
              description: this.formData.description || null,
              amount: this.formData.amount || null,
              account_number: this.formData.account_number || null,
              branch_id: this.formData.branch_id || null,
              delivery_user_id: this.formData.delivery_user_id || null,
              employee_id: this.formData.employee_id || null,
              rent_start_date: this.formData.rent_start_date || null,
              rent_end_date: this.formData.rent_end_date || null,
              transfer_from_branch_id: this.formData.transfer_from_branch_id || null,
              transfer_to_branch_id: this.formData.transfer_to_branch_id || null
            }

            // Edit үед id нэмэх
            if (this.formData.id) {
              payload.id = this.formData.id
            }

            // Debug: Payload-г хэвлэх
            console.log('Cost Payload:', payload)
            console.log('isTransferType:', this.isTransferType)
            console.log('transfer_from_branch_id:', this.formData.transfer_from_branch_id)
            console.log('transfer_to_branch_id:', this.formData.transfer_to_branch_id)

            let response
            if (this.formData.id) {
              response = await services.update('costs', payload)
            } else {
              response = await services.create('costs', payload)
            }
            if (response) {
              ElMessage.success(this.formData.id ? 'Амжилттай шинэчиллээ!' : 'Амжилттай үүсгэлээ!')
              this.handleClose()
              this.$emit('refresh')
            }
          } catch (error) {
            console.error('API Request Error:', error.message)
            ElMessage.error(error.message || 'Алдаа гарлаа')
          }
        } else {
          // Form validation failed
          return false
        }
      })
    },
    async loadBranches () {
      try {
        const response = await services.get('branchesWeb')
        if (response && response.type === 'success') {
          this.branches = response.data || []
        } else if (response && response.data) {
          this.branches = response.data || []
        }
      } catch (error) {
        console.error('Error loading branches:', error)
        this.branches = []
      }
    }
  }
}
</script>

<style scoped>
  .el-form {
    max-width: 100%;
  }
</style>
